// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"36":"6de8bb36","116":"4deea601","512":"eac41507","524":"d45ca2cc","604":"ab0b25e2","668":"bb5a8b82","812":"bf640385","824":"16868d68","840":"e3b91336"}[chunkId] + ".chunk.js";
};